export class LibQCFAWorkFileRequest {
    /** The library barcodes. */
	libraryBarcodes: string[];
	/** The machine type. */
	machineType: string;
	/** The fa plate barcode. */
	faPlateBarcode: string;
}